import * as React from "react";

function Settings({color="var(--color-blue-500)",...props}) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 22 22" fill="none" {...props}>
      <path
        d="M18.083 13.402c.142-.433.625-.842 1.084-.9l1.008-.134a.973.973 0 00.825-.942v-1a.98.98 0 00-.825-.942l-1.017-.134c-.458-.058-.941-.466-1.083-.9l-.333-.8c-.217-.409-.167-1.034.108-1.4l.625-.826c.275-.367.233-.934-.092-1.25l-.666-.668c-.325-.325-.892-.358-1.259-.083l-.841.642c-.367.275-.992.333-1.4.125-.4-.209-1.6-.934-1.659-1.392l-.125-1.042c-.058-.459-.475-.834-.933-.834h-1a.98.98 0 00-.942.825L9.425 2.79c-.058.459-.467.942-.9 1.084l-.808.334c-.4.208-1.034.158-1.4-.125l-.825-.626a.982.982 0 00-1.25.084l-.667.667c-.325.333-.358.892-.075 1.25l.625.8c.283.367.342.993.125 1.393l-.333.808c-.142.434-.634.842-1.084.9l-1.008.126a.98.98 0 00-.825.942v1c0 .459.375.884.825.934l.992.125c.458.058.941.459 1.083.9l.333.81c.209.408.167 1.041-.108 1.408l-.608.825c-.267.367-.225.934.1 1.26l.666.666c.325.325.892.359 1.259.084l.808-.617c.367-.276 1-.334 1.4-.126.408.209 1.608.943 1.675 1.393l.133 1.008a.973.973 0 00.942.826h1a.98.98 0 00.942-.826l.133-1.017c.058-.458.467-.942.9-1.083l.783-.317c.409-.209 1.042-.159 1.409.108l.825.609c.366.275.933.225 1.258-.1l.667-.667a.984.984 0 00.083-1.25l-.617-.81c-.275-.366-.333-.991-.125-1.4.217-.4.325-.767.325-.767z"
        stroke={color}
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M11 7.174a3.75 3.75 0 013.75 3.751 3.75 3.75 0 11-6.528-2.52"
        stroke={color}
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
    </svg>
  );
}

export default Settings;
